import React, {useState, useEffect} from 'react';
import {collection, getDocs, onSnapshot, query, orderBy} from 'firebase/firestore';
import {auth ,db, makeRandomTeam} from '../utils/firebase-config';
import {Table, Button, Popover, OverlayTrigger, Modal, Card, CardGroup} from 'react-bootstrap';
import '../css/teams.css';

function TeamsPage() {
    //constants
    const [allteams, setAllTeams] = useState([]);
    const teamsCollRef = collection(db, "teams");
    //functions
    const getTeams = async() => {
        getDocs(teamsCollRef).then((finaluserdata) => {
            setAllTeams(finaluserdata.docs.map((doc) => ({...doc.data(), id: doc.id})));
        })
    }
    const splitEvery = (array, length) => 
        array.reduce(
            (result, item, index) => {
            if ( index % length === 0 ) result.push([])
            result[Math.floor(index / length)].push(item)
            return result
            },
            []
        )
    
    

    //preloading
    useEffect(() => {
        getTeams();
        console.log(allteams);
    }, [])
    // to leave out <Button variant="primary" onClick={() => makeRandomTeam()}>make random team</Button>
    //return
    return (
        <div width="90%">
            <h1>teams page</h1>
            *make team button that pops up modal to make the team
            <p>* if user is already in a team then show current team here</p>
            <p>* some sort of table of teams here that you can join</p>
            
            {splitEvery(allteams, 3).map((usersChunk) => {
                return  <>
                <CardGroup style={{ width: '80%' , marginLeft: '10%'}}>
                { usersChunk.map( team => (
                    <Card className="teamcard" style={{ width: '18rem'}}>
                        <Card.Img className="image" variant="top" src={team.logo}/>
                        <Card.Body>
                            <Card.Title>{team.name}</Card.Title>
                            <Card.Text>
                            {team.players.map((player) => {
                                return  <>
                                    <p>{player.valo_name}</p>
                                </>
                            })}
                            </Card.Text>        
                        </Card.Body>
                        <Card.Footer>
                            <Button variant="primary">leave/join button if team not full</Button>
                        </Card.Footer>
                    </Card>
                ))}  
                </CardGroup>
                </>
            })}
        </div>
    )
}
    
export default TeamsPage